import { RetailCartValue } from "@/dto/retailCartValue";
import { ScanToOrderCartItemRight } from "./scanToOrderCartItemRight";
import { ScanToOrderCartItemLeft } from "./scanToOrderCartItemLeft";
import { useRouter } from "next13-progressbar";
import { getFromLocalStorage } from "@/utils/localStorageUtils";
import { LocalStorageKey } from "@/utils/storageKeys";
import { buildScanToOrderSearchParams } from "@/utils/scanToOrderUtils";
import { ScanToOrderInfo } from "@/dto/scanToOrderInfo";
import { getPrice } from "@/utils/getPrice";
import { getItemUrl } from "@/utils/itemUrlUtils";
import { useSearchParams } from "next/navigation";

export interface ScanToOrderCartItemProps {
  item: RetailCartValue;
  index: number;
  // eslint-disable-next-line no-unused-vars
  removeFromCart?: (event: React.MouseEvent, index: number) => void;
  onRequestClose: () => void;
  isAlreadySentToKitchen?: boolean;
}
export const ScanToOrderCartItem = ({
  item,
  index,
  removeFromCart,
  onRequestClose,
  isAlreadySentToKitchen,
}: ScanToOrderCartItemProps) => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const menuName = searchParams?.get("menu");
  const scanToOrderInfo = getFromLocalStorage<ScanToOrderInfo | null>(
    LocalStorageKey.SCAN_TO_ORDER_INFO,
    null
  );
  const handleItemClick = () => {
    let queryParams = "";
    if (scanToOrderInfo) {
      queryParams = buildScanToOrderSearchParams(scanToOrderInfo);
    }
    if (menuName) {
      queryParams += "&menu=" + menuName;
    }
    router.push(`/menu/${getItemUrl(item)}` + queryParams);
    onRequestClose();
  };

  const calculatedItemPrice = getPrice({
    item,
    itemModifiers: item.modifiers,
    quantity: item.quantity,
  });

  return (
    <div
      key={index}
      className="flex flex-col justify-between items-center py-4 border-b cursor-pointer"
      onClick={() => handleItemClick()}
    >
      <div className="w-full flex flex-row justify-between">
        <ScanToOrderCartItemLeft
          name={item?.name}
          quantity={item?.quantity}
          isAgeRestricted={item?.isAgeRestricted}
          modifiers={item?.modifiers}
          specialInstructions={item.specialInstructions}
        />
        <ScanToOrderCartItemRight
          index={index}
          price={isAlreadySentToKitchen ? item?.price : calculatedItemPrice}
          removeFromCart={removeFromCart}
        />
      </div>
    </div>
  );
};
